import React from "react";
import {useNavigate} from "react-router";
import {BookingStatus, InvalidServiceFeeChargeTypes} from "../../constants/securspace-constants";
import {sendBookingConfirmationEmail} from "../../../views/requests/booking-requests";
import {withSnackbar} from "../../hocs/withSnackbar";
import {adjustBookingTypes, updatePendingBookingActions} from "../../../views/booking-overview/SupplierBooking";
import moment from "moment";
import BookingCard from "../../BookingCard";

const SupplierBookingCardItem = ({
                                   booking,
                                   headerCells,
                                   userIsAdmin,
                                   snackbarShowMessage,
                                   handleSelectAdjustBooking,
                                   handleUpdatePendingBooking
                                 }) => {

  const {id, buyerEmail} = booking;

  const history = useNavigate();
  const buttons = [];

  const adjustEndDateStatuses = ['Approved', 'Complete', 'Processing-ACH-Payment'];
  const adjustSpacesStatuses = ['Approved'];
  const pendingStatuses = ['Pending', 'Pending Verification Required'];

  const bookingIsInactive = moment(booking.endDate).isBefore(moment(), "day") || booking.active === false;

  const declinedHeaderCells = [
    {id: 'reasonDeclined', label: 'REASON DECLINED'},
    {id: 'reasonDeclinedNote', label: 'REASON DECLINED NOTE'}
  ];

  const updatedHeaderCells = booking.status === BookingStatus.DECLINED
    ? [...headerCells, ...declinedHeaderCells]
    : headerCells;

  const sendConfirmationEmail = async (booking) => {
    try {
      await sendBookingConfirmationEmail(booking.id);
      snackbarShowMessage(`Confirmation email sent successfully: ${buyerEmail}`, 'success');
    } catch (error) {
      snackbarShowMessage(`Failed to send confirmation email: ${error}`, 'error')
    }
  }

  const navigateToServiceFeeCreation = (booking) => {
    history(`/booking/${booking.id}/charge-service-fee`, {state: {booking}});
  }

  const shouldShowAdjustEndDate = adjustEndDateStatuses.includes(booking.status) && userIsAdmin && !bookingIsInactive;

  const shouldShowAdjustSpaces = booking.frequency !== 'ONE_TIME' && adjustSpacesStatuses.includes(booking.status) && userIsAdmin && !bookingIsInactive;

  if (booking?.active === 'Active') {
    buttons.push(
      {
        label: 'Resend Confirmation Email',
        onClick: sendConfirmationEmail,
        variant: 'outlined'
      }
    );
  }
  if (!InvalidServiceFeeChargeTypes.includes(booking.status) && !bookingIsInactive) {
    buttons.push(
      {
        label: 'Charge Service Fee',
        onClick: navigateToServiceFeeCreation,
        variant: 'outlined'
      }
    );
  }

  if (shouldShowAdjustEndDate) {
    buttons.push(
      {
        label: 'Adjust End Date',
        onClick: () => handleSelectAdjustBooking(booking, adjustBookingTypes.DATE),
        variant: 'outlined'
      }
    )

  }
  if (shouldShowAdjustSpaces) {
    buttons.push(
      {
        label: 'Adjust Spaces',
        onClick: () => handleSelectAdjustBooking(booking, adjustBookingTypes.SPACES),
        variant: 'outlined'
      }
    )
  }

  if (pendingStatuses.includes(booking.status)) {
    buttons.push(
      {
        label: 'Approve',
        onClick: () => handleUpdatePendingBooking(booking, updatePendingBookingActions.APPROVE),
        variant: "text",
        styles: {
          color: (theme) => theme.palette.success.main,
          border: (theme) => `1px solid ${theme.palette.success.main}`,
        }
      },
      {
        label: 'Decline',
        onClick: () => handleUpdatePendingBooking(booking, updatePendingBookingActions.DECLINE),
        variant: 'text',
        styles: {
          color: (theme) => theme.palette.error.main,
          border: (theme) => `1px solid ${theme.palette.error.main}`,
        }
      }
    )
  }

  return (
    <BookingCard
      headCells={updatedHeaderCells}
      key={id}
      data={booking}
      buttons={buttons}
      bookingType='supplier'
    />
  );
};

export default withSnackbar(SupplierBookingCardItem);
